import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const Aeroexpress: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="Aeroexpress" onDelete={onServiceDelete}>
			{content => <>{content}</>}
		</ServiceSummary>
	);
};

export default Aeroexpress;
